import { FETCH_PSEUDOGROUPS } from '../actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_PSEUDOGROUPS:
			return action.payload;
		default:
			return state;
	}
};
